export class AttachmentModalData {
    entityType: string;
    parentId: number;
    parentType: string;
    entityName: string;
    entityDescription: string;
    belowParcelEntity: AttachmentModalEntityData;
    entityData: AttachmentModalEntityData;
    year: number;
    disableYears: boolean;
    singleYear: boolean;
    readOnly: boolean = false;
    startOnPhotos: boolean;
    parentTypeId?: number;
    disableCategories?: boolean;
    attachmentCategoryId?: Core.AttachmentCategories;
    attachmentTypeId?: Core.AttachmentTypes;
    showEmailAttachmentButton?: boolean;
    selectedAttachmentId?: System.Guid;
    uploadFile?: File;
    bundlerContext?: AttachmentBundlerContext;
    canUseCustomOrdering?: boolean;
    isCustomOrderingEnabled?: boolean;
}

/**
 * Context passed from the Attachment modal to the Bundler modal
 * to prepopulate entity filters, further-limit criteria, and disable already-attached items.
 */
export interface AttachmentBundlerContext {
    /** Bundler scope */
    bundlerSource: Core.AttachmentBundlerScopeEnum;
    /** Company ID for entity filter prepopulation */
    companyId: number;
    /** Top-level (parent) company ID for the company referenced by {@link companyId}.*/
    topLevelCompanyId?: number;
    /** Whether the company is a top-level company (true) or subsidiary (false). Used to determine the correct backend query path. */
    isTopLevelCompany?: boolean;
    /** Site IDs for entity filter prepopulation */
    siteIds: number[];
    /** Parcel account numbers for entity filter prepopulation */
    parcelIds: number[];
    /** Tax year for further-limit filter */
    year: number;
    /** Default attachment locations (e.g., Site/Parcel/Assessment/Appeal/Tax Bill) */
    defaultLocations: Core.AttachmentBundlerLocationEnum[];
    /** Default attachment category IDs (e.g., 1/2/3/4/14) */
    defaultCategories: Core.AttachmentCategories[];
    /**
     * Default attachment type IDs to preselect in the further-limit filter (e.g., Appeal Decision).
     * Use this when a specific attachment type must be preselected rather than a whole category.
     */
    defaultAttachmentTypes?: Core.AttachmentTypes[];
    /** Attachment IDs already attached (non-selectable in Bundler) */
    alreadyAttachedIds: string[];
    /**
     * Optional non-blocking warning shown when the source could not resolve all expected
     * entities (e.g., some parcel account numbers could not be resolved to parcel IDs).
     */
    parcelResolutionWarning?: string;
}

export class AttachmentModalEntityData {
    typeId: number;
    id: number;
    name: string;
}
